import * as React from 'react';

import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

export const NounIconInvoice: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style} viewBox="0 0 100 100">
        <path d="M85.9,25.62H66.67a1.82,1.82,0,0,1-1.81-1.82V8.2M68,5.1,85.37,22.51l.19.22a1.87,1.87,0,0,1,.34,1.07V85.39a1.81,1.81,0,0,1-1.81,1.81H24.14a1.81,1.81,0,0,1-1.81-1.81v-79a1.81,1.81,0,0,1,1.81-1.82H66.67A1.78,1.78,0,0,1,67.8,5ZM66.67,25.62a1.82,1.82,0,0,1-1.81-1.82V4.57" />
        <path d="M30.56,49.17H77.67" />
        <path d="M30.56,58.77H77.67" />
        <path d="M30.56,68.37H77.67" />
        <path d="M30.56,78H54.11" />
        <path d="M77.67,87.2v6.41a1.81,1.81,0,0,1-1.81,1.82H15.91a1.81,1.81,0,0,1-1.81-1.82v-79a1.81,1.81,0,0,1,1.81-1.81h6.42M74,87.2H24.14a1.81,1.81,0,0,1-1.81-1.81v-69" />
        <path d="M37,29.91a5.06,5.06,0,0,0,5.3,4.78,5.07,5.07,0,0,0,5.31-4.78,5.07,5.07,0,0,0-5.31-4.78c-3.65,0-5.3-2.15-5.3-4.79a5.06,5.06,0,0,1,5.3-4.78,5.07,5.07,0,0,1,5.31,4.78" />
        <line x1="42.12" y1="15.56" x2="42.12" y2="12.27" />
        <line x1="42.12" y1="37.98" x2="42.12" y2="34.69" />
    </SVGWrapper>
);
